<!-- HEADER NEW ACCOUNT-->
<h2 class="text-center font-header-auth mb-4"> {{'signup.title' | translate | uppercase}} </h2>

<!-- DESCRIPTION -->
<p class="text-center font-primary mx-4"> {{'signup.subheader' | translate }} </p>

<div class="col-10 m-auto">
    <hr class="text-muted mb-4">
</div>

<!-- TABS NEW ACCOUNT -->
<form class="tabs justify-content-center m-auto">
    <!-- TAB 1 -->
    <input type="radio" class="tabs_radio" name="tabsAccount" id="tab1"checked>
    <label for="tab1" class="tabs_label subheader-primary">{{'signup.welcome' | translate | titlecase}}</label>
    <div class="tabs_content my-4 animate__animated animate__fadeIn">
        <!-- WELCOME FORM -->
        <div class="my-3">
            <app-welcome-code></app-welcome-code>
        </div>
    </div>

    <!--! TAB 2 -->
    <!-- <input type="radio" class="tabs_radio" name="tabsAccount" id="tab2" >
    <label for="tab2" class="tabs_label subheader-primary">{{'signup.emailAddress' | translate }}</label>
    <div class="tabs_content my-4 animate__animated animate__fadeIn"> -->
        <!-- EMAIL FORM -->
         <!-- <div class="my-3">
            <app-email-address></app-email-address>          
        </div>
    </div>  -->
</form>
